const CycleRunPipeLineFilters = [
	{
		displayName: 'Not Started',
		name: 'notStarted',
		filter: { status: 'notStarted' },
		icon: 'icons8-add',
		iconStyle: { color: '#1890FF' },
	},
	{
		displayName: 'In Progress',
		name: 'inProgress',
		filter: { status: 'inProgress' },
		icon: 'icons8-maintenance',
		iconStyle: { color: '#FAAD14' },
	},
	{
		displayName: 'Ready For Approval',
		name: 'readyForApproval',
		filter: { status: 'readyForApproval' },
		icon: 'icons8-clipboard-checklist',
		iconStyle: { color: '#722ED1' },
	},
	{
		displayName: 'Approved',
		name: 'approved',
		filter: { status: 'approved' },
		icon: 'icons8-wrench',
		iconStyle: { color: '#52C41A' },
	},
	{
		displayName: 'Changes Applied',
		name: 'changesApplied',
		filter: { status: 'changesApplied' },
		icon: 'icons8-test-passed',
		iconStyle: { color: '#13C2C2' },
	},
];

export default CycleRunPipeLineFilters;
